import { toLabeledValues as to } from '../../../utils/labeledValues'
import {
  ConstructionAdminSubmittal,
  FromLabeledValuesValue,
  ReportOption,
} from './types'
import { SEPARATOR } from '../../types'
import { DefaultOptionType } from '../../../types'
import { Report } from 'shared'
import { errorHandler } from 'hooks/errorHandler'

export function toLabeledValues(items: ReportOption[] | undefined | null) {
  return to(items, {
    type: 'callback',
    callback: (item) => {
      let label, tooltip
      if (item.__typename === 'AsphaltLot') {
        label = item.asphaltLotId
        tooltip = Report.AsphaltLot.classTypeName
      } else if (item.__typename === 'ConstructionAdminSubmittal') {
        label = item.packageNumber
        tooltip = Report.ConstructionAdminSubmittal.classTypeName
      } else if (item.__typename === 'ConcretePlacement') {
        label = item.placementId
        tooltip = Report.ConcretePlacementCoreSheet.classTypeName
      } else if (item.__typename === 'ConcreteTest') {
        label = item.fieldNumber
        tooltip = Report.ConcreteTestSetCylinders.classTypeName
      } else if (item.__typename === 'ConcreteTestSet') {
        label = item.testSetId
        tooltip = Report.ConcreteTestSet.classTypeName
      } else if (item.__typename === 'DailyInspectionControlPoint') {
        label = item.controlPointId
        tooltip = Report.ControlPoint.classTypeName
      } else if (item.__typename === 'DailyInspectionInspection') {
        label = item.inspectionId
        tooltip = Report.Inspection.classTypeName
      } else if (item.__typename === 'DailyInspectionPunchList') {
        label = item.punchListId
        tooltip = Report.PunchList.classTypeName
      } else if (item.__typename === 'Lot') {
        label = item.lotId
        tooltip = Report.DensityLot.classTypeName
      }
      return { label: label ?? getId(item), value: join(item), tooltip }
    },
  })
}

export function split(
  value: DefaultOptionType['value']
): FromLabeledValuesValue {
  const [typename, itemId] =
    (value?.toString().split(SEPARATOR) as [
      ReportOption['__typename'],
      string
    ]) ?? []
  if (!typename)
    throw errorHandler(
      `Failed to split Report record: invalid typename ${typename}`
    )
  const [{ id }] = Report.filterByClassType(typename)
  return { reportId: itemId, reportTypeId: id }
}

export function join(item: ReportOption) {
  if (item.__typename === 'ConstructionAdminSubmittal')
    return `${item.__typename}${SEPARATOR}${item.id}`
  return `${item.__typename}${SEPARATOR}${getId(item)}`
}

function getId(item: ReportOption) {
  if (item.__typename === 'ConstructionAdminSubmittal') return item.id
  return (item as Exclude<ReportOption, ConstructionAdminSubmittal>).globalId
}
